import React from "react"

import adminTracking from "@irati-tracking/admin"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Body} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"

import {SETTINGS_LOGIN_INTEGRATION_DSYNC} from "../../routes/routeConfig"
import {Container, StyledMarkdown, ContainerImg} from "./styled"

interface Props extends InjectIntl {
  show: boolean
}

const DsyncIntegrationBanner: React.FC<Props> = ({show, formatMessage}) => {
  const handleOnClick = () => {
    adminTracking.navigationClickDsyncIntegrationPage()
  }

  if (!show) return null

  return (
    <Container padding={[3, 6]} marginBottom={3}>
      <Flex direction="column" gap flex="1 1 300px">
        <Flex alignItems="center" gap>
          <img width="20px" height="20px" src={formatMessage({id: "admin.manageUsers.dsyncIntegration.img"})} alt="" />
          <Body small color={theme.colors.greys.white} weight="default">
            <FormattedMessage id="admin.manageUsers.dsyncIntegration.hint" />
          </Body>
        </Flex>

        <StyledMarkdown source={formatMessage({id: "admin.manageUsers.dsyncIntegration.content"})} />

        <Flex alignItems="center">
          <ButtonRouterLink primary small inverted to={SETTINGS_LOGIN_INTEGRATION_DSYNC} onClick={handleOnClick}>
            <FormattedMessage id="admin.manageUsers.dsyncIntegration.button.more" />
          </ButtonRouterLink>
        </Flex>
      </Flex>

      <Flex direction="column" alignItems="center" justifyContent="center">
        <ContainerImg src={formatMessage({id: "admin.components.integration.directorySync.hris.img"})} alt="" />
        <ContainerImg src={formatMessage({id: "admin.components.integration.directorySync.hris.img"})} alt="" />
      </Flex>
    </Container>
  )
}

export default injectIntl(DsyncIntegrationBanner)
